var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloseCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c-0.007-5.52-4.48-9.993-9.999-10h-0.001zM18.482 17.575c-1.576 1.818-3.889 2.96-6.469 2.96-4.721 0-8.548-3.827-8.548-8.548s3.827-8.548 8.548-8.548c4.721 0 8.548 3.827 8.548 8.548 0 0.004 0 0.009 0 0.013v-0.001c-0.002 2.137-0.789 4.090-2.088 5.586l0.009-0.011z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.539 9.523l-2.478 2.477 2.478 2.478c0.136 0.136 0.22 0.323 0.22 0.531 0 0.414-0.336 0.75-0.75 0.75-0.207 0-0.395-0.084-0.531-0.22l-2.477-2.478-2.478 2.478c-0.136 0.136-0.323 0.22-0.531 0.22-0.414 0-0.75-0.336-0.75-0.75 0-0.207 0.084-0.395 0.22-0.531l2.478-2.478-2.478-2.477c-0.136-0.136-0.22-0.323-0.22-0.531 0-0.414 0.336-0.75 0.75-0.75 0.207 0 0.395 0.084 0.531 0.22l2.478 2.478 2.477-2.478c0.136-0.136 0.323-0.22 0.531-0.22 0.414 0 0.75 0.336 0.75 0.75 0 0.207-0.084 0.395-0.22 0.531v0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-circle.1720b4e7.svg";
export { ForwardRef as ReactComponent };